import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            联系我们
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            欢迎动漫创作者和内容提供方与我们取得联系
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-10">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed text-center max-w-2xl mx-auto">
            {contactData.desc}
          </p>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-5">
            <div className="flex flex-col items-center p-5 bg-background-100 rounded-xl">
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mb-3">
                <i className="ri-mail-line text-xl text-primary-600"></i>
              </div>
              <span className="text-xs text-foreground-500 mb-1">电子邮箱</span>
              <span className="text-sm font-medium text-foreground-800">{contactData.email}</span>
            </div>

            <div className="flex flex-col items-center p-5 bg-background-100 rounded-xl">
              <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mb-3">
                <i className="ri-wechat-line text-xl text-accent-600"></i>
              </div>
              <span className="text-xs text-foreground-500 mb-1">微信</span>
              <span className="text-sm font-medium text-foreground-800">{contactData.wechat}</span>
            </div>

            <div className="flex flex-col items-center p-5 bg-background-100 rounded-xl">
              <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center mb-3">
                <i className="ri-qq-line text-xl text-secondary-600"></i>
              </div>
              <span className="text-xs text-foreground-500 mb-1">QQ群</span>
              <span className="text-sm font-medium text-foreground-800">{contactData.qq}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}